module.exports = __webpack_public_path__ + "img/jardin5.f1f7c7d0.jpg";